import { restClient } from '../../client';
import { CollaborativeAgreementSigned, CollaborativeAgreementUnsigned } from './collaborativeAgreements';


export enum ProviderDocumentType {
  collaborativeAgreementUnsigned = 'collaborative_agreement_unsigned',
  collaborativeAgreement = 'collaborative_agreement',
  collaborativeAgreementCounterSignatureRequired = 'collaborative_agreement_counter_signature_required',
  collaborativeAgreementCounterSigned = 'collaborative_agreement_counter_signed',
}


export type ProviderCollaborativeAgreementDocument = {
  type: ProviderDocumentType.collaborativeAgreement;
  id: string;
  datetime: string;
  document: CollaborativeAgreementSigned;
};

export type ProviderCollaborativeAgreementDocumentUnsigned = {
  type: ProviderDocumentType.collaborativeAgreementUnsigned;
  id: string;
  datetime: null;
  document: CollaborativeAgreementUnsigned;
};

export type ProviderCollaborativeAgreementCounterSignatureRequired = {
  type: ProviderDocumentType.collaborativeAgreementCounterSignatureRequired;
  id: string;
  datetime: string;
  document: CollaborativeAgreementSigned;
};

export type ProviderCollaborativeAgreementCounterSigned = {
  type: ProviderDocumentType.collaborativeAgreementCounterSigned;
  id: string;
  datetime: string;
  document: CollaborativeAgreementSigned;
};

export type ProviderDocument =
  | ProviderCollaborativeAgreementDocument
  | ProviderCollaborativeAgreementDocumentUnsigned
  | ProviderCollaborativeAgreementCounterSignatureRequired
  | ProviderCollaborativeAgreementCounterSigned;


export const getProviderDocuments = async (providerId: string) => restClient.request<{ data: ProviderDocument[] }>(`/api/v1/provider/${providerId}/documents`, {
  method: 'GET',
});
